import { retriableLazyImport } from '@gcx-si/vue-components/retriableLazyImport'

import type { RouteRecordRaw } from 'vue-router'

import { constants } from '@/globals'

export default {
  path: 'device-types',
  meta: {
    navigation: {
      labelKey: 'app.device_types.pages.overview.title',
      targetName: constants.ROUTES_DEVICE_TYPES,
    },
  },
  children: [
    {
      path: '',
      component: retriableLazyImport(() => import('./pages/Overview.vue')),
      name: constants.ROUTES_DEVICE_TYPES,
      meta: {
        permission: {
          scope: 'read:device_type',
        },
      },
    },
    {
      path: ':deviceTypeId',
      component: retriableLazyImport(() => import('./pages/Details.vue')),
      name: constants.ROUTES_DEVICE_TYPE,
      meta: {
        permission: {
          scope: 'read:device_type',
        },
      },
    },
    {
      path: 'create',
      component: retriableLazyImport(() => import('./pages/Details.vue')),
      name: constants.ROUTES_DEVICE_TYPE_CREATE,
      meta: {
        permission: {
          scope: 'write:device_type',
        },
      },
    },
  ],
} as RouteRecordRaw
